import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { environment } from '@environments/environment';
import { DEV_TENANTS, DevTenantKey, getActiveDevTenantKey, setDevTenant } from '@environments/dev-tenants.config';

@Component({
  selector: 'app-tenant-switcher',
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './tenant-switcher.html',
  styleUrl: './tenant-switcher.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantSwitcherComponent {
  // environment.tenants/defaultTenantKey are only present in dev tiers, and this
  // component is not in the production bundle at all (#906), so the
  // DEV_TENANTS/'localhost' fallbacks below only satisfy TypeScript.
  readonly tenants = environment.tenants ?? DEV_TENANTS;
  readonly tenantKeys = Object.keys(this.tenants) as DevTenantKey[];
  readonly activeKey = getActiveDevTenantKey() ?? environment.defaultTenantKey ?? 'localhost';

  // Drives the persistent marking on the trigger button. Writes against a
  // production backend are real, and the confirmation below is seen once per
  // switch — this is what keeps that visible for the rest of the session.
  readonly isProductionActive = this.tenants[this.activeKey].productionBackend;

  selectTenant(key: DevTenantKey): void {
    if (key === this.activeKey) return;

    const tenant = this.tenants[key];
    if (tenant.productionBackend) {
      // window.confirm rather than MatDialog: setDevTenant() clears storage and
      // reloads synchronously, and a dialog would make this path async for a
      // toolbar that only ever exists in dev builds.
      const warning =
        `${tenant.label} is a LIVE production backend.\n\n` +
        'You will be reading and writing real customer data — bookings you create are real bookings.\n\n' +
        'Continue?';
      if (!window.confirm(warning)) return;
    }

    setDevTenant(key);
  }
}
